import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, Box } from '@mui/material';
import { Helmet } from 'react-helmet';
import StaticPageLayout from '../components/StaticPageLayout';

const CityPage: React.FC = () => {
  const { cityId } = useParams<{ cityId: string }>();
  
  // Convert cityId to display name
  const getCityName = (id: string) => {
    return id.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  
  const cityName = getCityName(cityId || '');
  
  return (
    <StaticPageLayout>
      <Helmet>
        <title>{`Businesses in ${cityName} | ET-Business Directory`}</title>
        <meta name="description" content={`Find verified businesses in ${cityName}, Ethiopia. Browse comprehensive listings of companies and services in ${cityName} with contact information and locations.`} />
      </Helmet>
      
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Businesses in {cityName}
        </Typography>
        
        <Typography variant="body1" paragraph>
          Browse verified businesses and services in {cityName}. Find local companies with detailed information and contact details.
        </Typography>
        
        {/* Business listings will be added here */}
        <Box>
          <Typography variant="body1" color="text.secondary">
            Business listings are being updated. Please check back soon.
          </Typography>
        </Box>
      </Container>
    </StaticPageLayout>
  );
};

export default CityPage; 